import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../../assets/logo.png";
import appScreenshot from "../../../assets/app-screenshot.jpg";
import StarField from "../../StarField/StarField";
import styles from "./Home.module.scss";

const PHONE = "+79388950995";
const PHONE_DISPLAY = "+7 938 895-09-95";

const IconRuStore = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="2" width="20" height="20" rx="5" fill="#2E7DFF" />
    <path
      d="M8 7h5.2c2.1 0 3.5 1.4 3.5 3.3 0 1.4-.8 2.5-2 3l2.3 3.7h-2.4l-2-3.3H10v3.3H8V7zm2 1.7v3.3h3c1.1 0 1.8-.7 1.8-1.7s-.7-1.6-1.8-1.6H10z"
      fill="#fff"
    />
  </svg>
);

const IconGooglePlay = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.6 2.4c-.4.4-.6 1-.6 1.7v15.8c0 .7.2 1.3.6 1.7L12 12 3.6 2.4z" fill="#00E1FF" />
    <path d="M16.3 8.3L5.6 2.1c-.5-.3-1-.3-1.4-.1L13.7 12l2.6-3.7z" fill="#00E676" />
    <path d="M20.6 10.6l-4.3-2.3L13.7 12l2.6 3.7 4.3-2.3c1.2-.7 1.2-2.1 0-2.8z" fill="#FFC400" />
    <path d="M4.2 21.9c.4.2.9.2 1.4-.1l10.7-6.2-2.6-3.6-9.5 9.9z" fill="#FF3D00" />
  </svg>
);

const IconApple = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.1 12.6c0-2.4 2-3.5 2.1-3.6-1.1-1.7-2.9-1.9-3.5-1.9-1.5-.2-2.9.9-3.7.9-.8 0-1.9-.9-3.2-.8-1.6 0-3.1.9-4 2.4-1.7 3-.4 7.4 1.3 9.8.8 1.2 1.8 2.5 3.1 2.4 1.2 0 1.7-.8 3.2-.8s1.9.8 3.2.8c1.3 0 2.2-1.2 3-2.4.9-1.4 1.3-2.7 1.3-2.8-.1 0-2.6-1-2.7-4zM14.8 5.6c.6-.8 1.1-2 1-3.2-1 0-2.1.6-2.8 1.5-.6.7-1.2 1.9-1 3.1 1.1.1 2.2-.6 2.8-1.4z" />
  </svg>
);

const IconInstagram = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="3" width="18" height="18" rx="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.5" cy="6.5" r="1" fill="currentColor" />
  </svg>
);

const IconWhatsApp = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38a9.9 9.9 0 0 0 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.816 9.816 0 0 0 12.04 2Zm0 1.67c2.2 0 4.26.86 5.82 2.42a8.23 8.23 0 0 1 2.41 5.83c0 4.54-3.7 8.23-8.24 8.23-1.48 0-2.93-.39-4.19-1.15l-.3-.17-3.12.82.83-3.04-.2-.32a8.19 8.19 0 0 1-1.26-4.38c.01-4.54 3.7-8.24 8.25-8.24ZM8.53 7.33c-.16 0-.43.06-.66.31-.22.25-.87.86-.87 2.07s.89 2.39 1 2.56c.14.17 1.76 2.67 4.25 3.73.59.27 1.05.42 1.41.53.59.19 1.13.16 1.56.1.48-.07 1.46-.6 1.66-1.18.21-.58.21-1.07.15-1.18-.07-.1-.23-.16-.48-.27-.25-.14-1.47-.74-1.69-.82-.23-.08-.37-.12-.56.12-.16.25-.64.81-.78.97-.15.17-.29.19-.53.07-.26-.13-1.06-.39-2-1.23-.74-.66-1.23-1.47-1.38-1.72-.12-.24-.01-.39.11-.5.11-.11.27-.29.37-.44.13-.14.17-.25.25-.41.09-.17.05-.31-.01-.43-.06-.11-.56-1.35-.77-1.84-.2-.48-.4-.42-.56-.43-.14 0-.3-.01-.47-.01Z"
    />
  </svg>
);

const IconPhone = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 15.5c-1.2 0-2.5-.2-3.6-.6a1 1 0 00-1 .2l-2.2 2.2a15 15 0 01-6.6-6.6l2.2-2.2a1 1 0 00.2-1c-.4-1.1-.6-2.4-.6-3.6a1 1 0 00-1-1H4a1 1 0 00-1 1c0 9.4 7.6 17 17 17a1 1 0 001-1v-3.4a1 1 0 00-1-1z" />
  </svg>
);

const IconArrow = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5 12h14M13 6l6 6-6 6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const STORE_LINKS = [
  {
    href: "https://www.rustore.ru/catalog/app/com.smarttrans.client",
    icon: <IconRuStore />,
    small: "Доступно в",
    big: "RuStore",
  },
  {
    href: "https://play.google.com/store/apps/details?id=com.smarttrans.client&hl=ru&gl=ru",
    icon: <IconGooglePlay />,
    small: "Скачать в",
    big: "Google Play",
  },
  {
    href: "https://apps.apple.com/ru/app/smart-trans-%D0%B7%D0%B0%D0%BA%D0%B0%D0%B7-%D1%82%D0%B0%D0%BA%D1%81%D0%B8/id6478095820",
    icon: <IconApple />,
    small: "Загрузите в",
    big: "App Store",
  },
];

const Home: React.FC = () => {
  const [shotLoaded, setShotLoaded] = useState(false);

  return (
    <main className={styles.wrapper}>
      <StarField />

      <div className={styles.container}>
        <div className={styles.content}>
          <section className={styles.hero}>
            <div className={styles.brandRow}>
              <div className={styles.logoWrap}>
                <img src={logo} alt="" className={styles.logo} />
              </div>
              <h1 className={styles.title}>SMART Taxi</h1>
            </div>
            <p className={styles.subtitle}>
              Удобный сервис для заказа такси на всей территории Чеченской
              Республики
            </p>
          </section>

          <section className={styles.download} aria-label="Скачать приложение">
            <div className={styles.sectionLabel}>Скачайте приложение</div>
            <div className={styles.storeGrid}>
              {STORE_LINKS.map((s) => (
                <a
                  key={s.href}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.storeBtn}
                >
                  <span className={styles.storeIcon}>{s.icon}</span>
                  <span className={styles.storeText}>
                    <small>{s.small}</small>
                    <strong>{s.big}</strong>
                  </span>
                </a>
              ))}
            </div>
          </section>

          <a
            href="https://instagram.com/smart95taxi/"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.instaBtn}
          >
            <span className={styles.instaIcon}>
              <IconInstagram />
            </span>
            <span className={styles.instaText}>
              <small>Следите за нами</small>
              <strong>Instagram</strong>
            </span>
          </a>

          <Link to="/register" className={styles.primaryCta}>
            <span>Стать водителем</span>
            <IconArrow />
          </Link>
        </div>

        <aside className={styles.phoneCol} aria-hidden="true">
          <div className={styles.phoneGlow} />
          <div className={styles.phoneFrame}>
            {!shotLoaded && <div className={styles.phoneSkeleton} />}
            <img
              src={appScreenshot}
              alt=""
              width={460}
              height={995}
              decoding="async"
              className={`${styles.phoneImage}${
                shotLoaded ? " " + styles.phoneImageLoaded : ""
              }`}
              onLoad={() => setShotLoaded(true)}
              onError={() => setShotLoaded(true)}
            />
          </div>
        </aside>
      </div>

      <aside className={styles.contacts} aria-label="Связаться с нами">
        <a
          href={`https://wa.me/${PHONE.replace(/\D/g, "")}`}
          target="_blank"
          rel="noopener noreferrer"
          className={`${styles.contactBtn} ${styles.wa}`}
          aria-label={`WhatsApp ${PHONE_DISPLAY}`}
        >
          <IconWhatsApp />
        </a>
        <a
          href={`tel:${PHONE}`}
          className={`${styles.contactBtn} ${styles.tel}`}
          aria-label={`Позвонить ${PHONE_DISPLAY}`}
        >
          <IconPhone />
        </a>
      </aside>
    </main>
  );
};

export default Home;
